import React from 'react';
import Select, {components, ValueContainerProps} from "react-select";

const Option = (props) => {
    return (
        <components.Option {...props}>
            <label className="rf-checkbox-option">
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    className="rf-checkbox-input"
                />
                <span className="rf-checkbox-label">{props.label}</span>
            </label>
        </components.Option>
    );
};

const DropdownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg className="down-arrow-1"/>
            </components.DropdownIndicator>
        )
    );
};

const maxChips = 0;

const ValueContainer = ({ children, selectProps, getValue, ...props }: ValueContainerProps<any>) => {
    var length = getValue().length;
    let chips = React.Children.toArray(children).slice(0, length);
    let input = React.Children.toArray(children).slice(-1);

    const renderValue = () => {
        if(length === 0) return children;

        const inputIsEmpty =  selectProps.inputValue === "";
        const itemName = selectProps.placeholder ? (selectProps.placeholder + "'s") : "items";

        return (
            <div className="root" style={{ whiteSpace: 'nowrap' }}>
                {input}
                { inputIsEmpty && (
                    length > maxChips ?
                        <span style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{`${length} ${itemName}`}</span>
                        :
                        chips
                )
                }
            </div>
        )
    }

    return (
        <components.ValueContainer selectProps={selectProps} getValue={getValue} {...props}>
            {renderValue()}
        </components.ValueContainer>
    );
};

const CheckboxSelect = (props) => {
    const { options, styles, ...restProps } = props;

    return (
        <Select
            {...restProps}
            styles={{
                ...styles,
                clearIndicator: (base) => ({
                    ...base,
                    ...styles.clearIndicator,
                    padding: 0,
                }),
            }}
            components={{
                Option,
                ValueContainer,
                DropdownIndicator,
                IndicatorSeparator: () => null,
                MultiValueRemove: () => null,
            }}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            options={options}
        />
    );
};

export default CheckboxSelect;